import { EnvironmentProviders, inject, Injector, provideAppInitializer } from '@angular/core';
import { Router, Routes } from '@angular/router';

import { TranslationService } from '@translations';
import { ConfigService } from './config.service';

// Routes are applied only after the client/service configuration and the base translations have loaded.
export function provideConfigInitializer(routes: Routes): EnvironmentProviders {
    return provideAppInitializer(() => {
        const configService = inject(ConfigService);
        const router = inject(Router);
        const injector = inject(Injector);

        return configService.loadConfig()
            // Created only now: the translation requests need the client headers set by loadConfig().
            .then(() => injector.get(TranslationService).ready)
            .then(() => router.resetConfig(routes));
    });
}
